/*
 * 文件EN: artificialAudit.js,
 * 文件CN: 人工复核,
 * 创建时间: Wednesday, 29th April 2020 5:41:38 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import * as Models from '@/api/T3/artificialAudit'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 获取列表
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 ? res.data : {}
      })
    },

    // 提交审核
    async confirm(ctx, payload) {
      return await Models.confirm(payload)
    },

    // 历史系统审批
    async approvalHistory(ctx, payload) {
      return await Models.approvalHistory(payload)
    },


    // 上送 T3/artificialAudit/selectMerIdByBank
    async selectMerIdByBank(ctx, payload) {
      return await Models.selectMerIdByBank(payload)
    },

    // 审核报告导出pdf
    async auditReportExportPdf(ctx, payload) {
      return await Models.auditReportExportPdf(payload)
    },

  }
}